import { render, staticRenderFns } from "./UpsellRules.vue?vue&type=template&id=f3339828&scoped=true"
import script from "./UpsellRules.vue?vue&type=script&lang=js"
export * from "./UpsellRules.vue?vue&type=script&lang=js"
import style0 from "./UpsellRules.vue?vue&type=style&index=0&id=f3339828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3339828",
  null
  
)

export default component.exports